import { render, staticRenderFns } from "./PendingEstimations.vue?vue&type=template&id=8d322a18&"
import script from "./PendingEstimations.vue?vue&type=script&lang=js&"
export * from "./PendingEstimations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports